/**
 * @generated SignedSource<<1dcc72650448c47aa503da0199134393>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_navigationKitTabOld_Tab$data = {
  readonly label: string;
  readonly " $fragmentSpreads": FragmentRefs<"ui_navigationKitTabMenuOld_TabMenu">;
  readonly " $fragmentType": "ui_navigationKitTabOld_Tab";
};
export type ui_navigationKitTabOld_Tab$key = {
  readonly " $data"?: ui_navigationKitTabOld_Tab$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_navigationKitTabOld_Tab">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_navigationKitTabOld_Tab",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "label"
      },
      "action": "THROW",
      "path": "label"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_navigationKitTabMenuOld_TabMenu"
    }
  ],
  "type": "JiraNavigationItem",
  "abstractKey": "__isJiraNavigationItem"
};

(node as any).hash = "c625355e8e1cd39e8d1a3c10b9dfa2a6";

export default node;
